// extracted by mini-css-extract-plugin
export var centerText = "_4z-8";
export var container = "_4z-0";
export var doughnutContainer = "_4z-7";
export var legend = "_4z-a";
export var legendItemColorDisplay = "_4z-b";
export var legendItemLabel = "_4z-d";
export var legendItemValue = "_4z-c";
export var lg = "_4z-5";
export var maxWidth = "_4z-9";
export var md = "_4z-4";
export var responsive = "_4z-6";
export var sm = "_4z-3";
export var xs = "_4z-2";
export var xxs = "_4z-1";